export default (function (value) {
  return Array.isArray(value);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isArray.js
// module id = 1852
// module chunks = 0